import type { Mapping } from '@pn/core/domain/data';
import { setFields } from '@pn/resources/pn-mappings';
import stackWellsMapping from './stack_wells.jsonc';
import stackWellsUsaMapping from './stack_wells_usa.jsonc';

export const stackMappings: Record<string, Mapping> = setFields({
  wells: stackWellsMapping,
  wells_usa: stackWellsUsaMapping,
});
